import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {LoginService} from '@app/service/login.service';

@Directive({
    selector: '[appPermission]',
    standalone: true
})
export class PermissionDirective {

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private loginService: LoginService
    ) {
    }


    private rendered = false;

    @Input()
    set appPermission(val) {
      if (this.loginService.hasPermission(val)) {
            if (this.rendered) return;
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.rendered = true;
        } else {
            this.viewContainer.clear();
            this.rendered = false;
        }
    }
}
